function headerResizeListener() {
  let headerHeightOutput = document.querySelector(".header-wrapper");
  let headerAnnouncementOutput = document.querySelector(".announcement-bar");

  function initializeheaderResize() {
    let getHeight = headerHeightOutput.offsetHeight;
    let getAnnouncementHeight = headerAnnouncementOutput.offsetHeight;
    document.documentElement.style.setProperty('--header-height', `${getHeight}px`);
    document.documentElement.style.setProperty('--header-anouncement-height', `${getAnnouncementHeight}px`);
  }

  // Initialize on page load
  initializeheaderResize();

  // Reinitialize on window resize
  window.addEventListener("resize", initializeheaderResize);
}

headerResizeListener();

const headerMenuIcon = document.querySelector('.header__icon--menu');

headerMenuIcon.addEventListener('click', function() {
  let bodyMenu = document.querySelector('body');
  let headerHeightOutput = document.querySelector(".header-wrapper");
  let getHeight = headerHeightOutput.offsetHeight;
  document.documentElement.style.setProperty('--header-height', `${getHeight}px`);

  bodyMenu.classList.toggle('menu-open');
});

document.addEventListener('click', function(event) {
  if (event.target.classList.contains('next-section-scroll')) {
    const dataCurrentID = event.target.getAttribute('data-current-id');
    const targetToScroll = document.getElementById(dataCurrentID).nextElementSibling;

    if (targetToScroll) {
      // Calculate the position to scroll to, minus the header height
      const rootStyles = getComputedStyle(document.documentElement);
      const headerHeight = parseInt(rootStyles.getPropertyValue('--header-height'), 10);
      const targetPosition = targetToScroll.getBoundingClientRect().top + window.scrollY - headerHeight;

      // Scroll to the calculated position
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
    }
  }
});


let matchMedia = window.matchMedia("(min-width:768px)");
if(matchMedia.matches) {
  const marquees = [...document.querySelectorAll('.sale-banner__item')];
  marquees.forEach((marquee) => {
    marquee.innerHTML = marquee.innerHTML.repeat(5);
    marquee.i = 0;
    marquee.step = 2;
    marquee.width = marquee.clientWidth + 1;
    marquee.style.position = '';
    marquee.innerHTML = `${marquee.innerHTML}`.repeat(5);

    document.addEventListener('click', function(event) {
      if (event.target.classList.contains('ticker-pause')) {
        marquee.step = 0;
        marquee.parentNode.classList.add('pause');
      }
    });

    document.addEventListener('click', function(event) {
      if (event.target.classList.contains('ticker-play')) {
        marquee.step = 2;
        marquee.parentNode.classList.remove('pause');
      }
    });
  });

  requestAnimationFrame(move);

  function move() {
    marquees.forEach((marquee) => {
      marquee.style.marginLeft = `-${marquee.i}px`;
      marquee.i = marquee.i < marquee.width ? marquee.i + marquee.step : 1;
    });

    requestAnimationFrame(move);
  }
}

document.addEventListener('click', function(event) {
  if (event.target.classList.contains('show-password')) {
    let showPassword = document.querySelector('.show-password');
    let filed = showPassword.parentNode.getAttribute('data-id');
    showPassword.parentNode.classList.add('show-password-active');
    document.getElementById(filed).type = 'text';
  }
});

document.addEventListener('click', function(event) {
  if (event.target.classList.contains('hide-password')) {
    let hidePassword = document.querySelector('.hide-password');
    let filed = hidePassword.parentNode.getAttribute('data-id');
    hidePassword.parentNode.classList.remove('show-password-active');
    document.getElementById(filed).type = 'password';
  }
});

var shoplookSwiper = new Swiper(".shoplook-image-slider", {
  slidesPerView: 1,
  centeredSlides: false,
  speed: 700,
  loop: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
    enabled: false
  },
  scrollbar: {
    el: ".swiper-scrollbar",
    draggable: true,
    snapOnRelease: true,
    enabled: true
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
    enabled: false
  },
  breakpoints: {
    640: {
      slidesPerView: 2,
      centeredSlides: true
    },
    768: {
      slidesPerView: 1,
      centeredSlides: false,
      navigation: {
        enabled: true
      },
      scrollbar: {
        enabled: false
      },
      pagination: {
        enabled: true
      }
    }
  }
});

function swiperProductCard() {
  let initProductSlider = false;
  let swiperProductSlider;

  function initializeSwiper() {
    if (window.innerWidth <= 768) {
      if (!initProductSlider) {
        initProductSlider = true;
        swiperProductSlider = new Swiper(".shoplook-product-slider", {
          slidesPerView: 1.75,
          spaceBetween: 8,
          speed: 700,
          scrollbar: {
            el: ".swiper-scrollbar",
            draggable: true,
            snapOnRelease: true,
            enabled: true
          }
        });
      }
    } else {
      if (initProductSlider && swiperProductSlider) {
        swiperProductSlider.destroy();
        swiperProductSlider = undefined;
        initProductSlider = false;
      }
    }
  }

  // Initialize on page load
  initializeSwiper();

  // Reinitialize on window resize
  window.addEventListener("resize", initializeSwiper);
}

swiperProductCard();

var productSliderSwiper = new Swiper(".product-slider", {
  slidesPerView: 1.25,
  spaceBetween: 8,
  speed: 700,
  loop: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
    enabled: false
  },
  scrollbar: {
    el: ".swiper-scrollbar",
    draggable: true,
    snapOnRelease: true,
    enabled: true
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
    enabled: false
  },
  breakpoints: {
    375: {
      slidesPerView: 2.25,
    },
    768: {
      slidesPerView: 3.25,
      spaceBetween: 12,
      navigation: {
        enabled: true
      },
      scrollbar: {
        enabled: false
      },
      pagination: {
        enabled: true
      }
    },
    1025: {
      slidesPerView: 4.25,
      navigation: {
        enabled: true
      },
      scrollbar: {
        enabled: false
      },
      pagination: {
        enabled: true
      }
    }
  }
});

var getlookVideoSlider = new Swiper(".getlook-video-slider", {
  slidesPerView: 1.5,
  spaceBetween: 8,
  speed: 700,
  loop: false,
  cssMode: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
    enabled: false
  },
  scrollbar: {
    el: ".swiper-scrollbar",
    draggable: true,
    simulateTouch: true,
    enabled: true
  },
  breakpoints: {
    768: {
      slidesPerView: 3,
      spaceBetween: 12,
      navigation: {
        enabled: true
      },
      scrollbar: {
        enabled: true
      },
    }
  }
});

const acc = document.getElementsByClassName('section-collection-faq');
const accItem = document.getElementsByClassName('faq-item');
const accHD = document.getElementsByClassName('faq-item-heading');
for (i = 0; i < accHD.length; i++) {
  accHD[i].addEventListener('click', toggleItem, false);
}

if (accItem && accItem.length <= 0 && acc && acc.length) {
  document.querySelector('.section-collection-faq').remove();
}

for (i = 0; i < accItem.length; i++) {
  if (i == 0) {
    accItem[i].classList.add('open');
    accItem[i].classList.remove('close');
  }
}

function toggleItem() {
  let itemClass = this.parentNode.className;
  for (i = 0; i < accItem.length; i++) {
    accItem[i].className = 'faq-item close';
  }
  if (itemClass == 'faq-item close') {
    this.parentNode.className = 'faq-item open';
  }
}

document.addEventListener('DOMContentLoaded', (event) => {
  const scrollNewsletter = document.getElementById('scroll_newsletter');
  const newsletterSection = document.getElementById('newsletter');

  if (scrollNewsletter && newsletterSection) {
    const rootStyles = getComputedStyle(document.documentElement);
    const headerHeight = parseInt(rootStyles.getPropertyValue('--header-height'), 10);

    scrollNewsletter.addEventListener('click', () => {
      const targetPosition = newsletterSection.getBoundingClientRect().top + window.scrollY - headerHeight;
      window.scrollTo({ top: targetPosition, behavior: 'smooth' });
    });
  }
});

document.addEventListener('click', function(event) {
  const header = event.target.closest('.accordion-summary');
  if (header) {
    const item = header.parentElement;
    const content = item.querySelector('.accordion-content');
    const isActive = item.classList.contains('active');

    // Close all accordion items
    document.querySelectorAll('.accordion-item').forEach((accordionItem) => {
      accordionItem.classList.remove('active');
      accordionItem.querySelector('.accordion-content').style.display = 'none';
    });

    // Toggle the clicked accordion item
    if (!isActive) {
      item.classList.add('active');
      content.style.display = 'block';
    } else {
      item.classList.remove('active');
      content.style.display = 'none';
    }
  }
});

const countries = [
  {"name": "United States of America (the)", "code": "US"},
  {"name": "Albania", "code": "AL"},
  {"name": "Åland Islands", "code": "AX"},
  {"name": "Algeria", "code": "DZ"},
  {"name": "American Samoa", "code": "AS"},
  {"name": "Andorra", "code": "AD"},
  {"name": "Angola", "code": "AO"},
  {"name": "Anguilla", "code": "AI"},
  {"name": "Antarctica", "code": "AQ"},
  {"name": "Antigua and Barbuda", "code": "AG"},
  {"name": "Argentina", "code": "AR"},
  {"name": "Armenia", "code": "AM"},
  {"name": "Aruba", "code": "AW"},
  {"name": "Australia", "code": "AU"},
  {"name": "Austria", "code": "AT"},
  {"name": "Azerbaijan", "code": "AZ"},
  {"name": "Bahamas (the)", "code": "BS"},
  {"name": "Bahrain", "code": "BH"},
  {"name": "Bangladesh", "code": "BD"},
  {"name": "Barbados", "code": "BB"},
  {"name": "Belarus", "code": "BY"},
  {"name": "Belgium", "code": "BE"},
  {"name": "Belize", "code": "BZ"},
  {"name": "Benin", "code": "BJ"},
  {"name": "Bermuda", "code": "BM"},
  {"name": "Bhutan", "code": "BT"},
  {"name": "Bolivia (Plurinational State of)", "code": "BO"},
  {"name": "Bonaire, Sint Eustatius and Saba", "code": "BQ"},
  {"name": "Bosnia and Herzegovina", "code": "BA"},
  {"name": "Botswana", "code": "BW"},
  {"name": "Bouvet Island", "code": "BV"},
  {"name": "Brazil", "code": "BR"},
  {"name": "British Indian Ocean Territory (the)", "code": "IO"},
  {"name": "Brunei Darussalam", "code": "BN"},
  {"name": "Bulgaria", "code": "BG"},
  {"name": "Burkina Faso", "code": "BF"},
  {"name": "Burundi", "code": "BI"},
  {"name": "Cabo Verde", "code": "CV"},
  {"name": "Cambodia", "code": "KH"},
  {"name": "Cameroon", "code": "CM"},
  {"name": "Canada", "code": "CA"},
  {"name": "Cayman Islands (the)", "code": "KY"},
  {"name": "Central African Republic (the)", "code": "CF"},
  {"name": "Chad", "code": "TD"},
  {"name": "Chile", "code": "CL"},
  {"name": "China", "code": "CN"},
  {"name": "Christmas Island", "code": "CX"},
  {"name": "Cocos (Keeling) Islands (the)", "code": "CC"},
  {"name": "Colombia", "code": "CO"},
  {"name": "Comoros (the)", "code": "KM"},
  {"name": "Congo (the Democratic Republic of the)", "code": "CD"},
  {"name": "Congo (the)", "code": "CG"},
  {"name": "Cook Islands (the)", "code": "CK"},
  {"name": "Costa Rica", "code": "CR"},
  {"name": "Croatia", "code": "HR"},
  {"name": "Cuba", "code": "CU"},
  {"name": "Curaçao", "code": "CW"},
  {"name": "Cyprus", "code": "CY"},
  {"name": "Czechia", "code": "CZ"},
  {"name": "Côte d'Ivoire", "code": "CI"},
  {"name": "Denmark", "code": "DK"},
  {"name": "Djibouti", "code": "DJ"},
  {"name": "Dominica", "code": "DM"},
  {"name": "Dominican Republic (the)", "code": "DO"},
  {"name": "Ecuador", "code": "EC"},
  {"name": "Egypt", "code": "EG"},
  {"name": "El Salvador", "code": "SV"},
  {"name": "Equatorial Guinea", "code": "GQ"},
  {"name": "Eritrea", "code": "ER"},
  {"name": "Estonia", "code": "EE"},
  {"name": "Eswatini", "code": "SZ"},
  {"name": "Ethiopia", "code": "ET"},
  {"name": "Falkland Islands (the) [Malvinas]", "code": "FK"},
  {"name": "Faroe Islands (the)", "code": "FO"},
  {"name": "Fiji", "code": "FJ"},
  {"name": "Finland", "code": "FI"},
  {"name": "France", "code": "FR"},
  {"name": "French Guiana", "code": "GF"},
  {"name": "French Polynesia", "code": "PF"},
  {"name": "French Southern Territories (the)", "code": "TF"},
  {"name": "Gabon", "code": "GA"},
  {"name": "Gambia (the)", "code": "GM"},
  {"name": "Georgia", "code": "GE"},
  {"name": "Germany", "code": "DE"},
  {"name": "Ghana", "code": "GH"},
  {"name": "Gibraltar", "code": "GI"},
  {"name": "Greece", "code": "GR"},
  {"name": "Greenland", "code": "GL"},
  {"name": "Grenada", "code": "GD"},
  {"name": "Guadeloupe", "code": "GP"},
  {"name": "Guam", "code": "GU"},
  {"name": "Guatemala", "code": "GT"},
  {"name": "Guernsey", "code": "GG"},
  {"name": "Guinea", "code": "GN"},
  {"name": "Guinea-Bissau", "code": "GW"},
  {"name": "Guyana", "code": "GY"},
  {"name": "Haiti", "code": "HT"},
  {"name": "Heard Island and McDonald Islands", "code": "HM"},
  {"name": "Holy See (the)", "code": "VA"},
  {"name": "Honduras", "code": "HN"},
  {"name": "Hong Kong", "code": "HK"},
  {"name": "Hungary", "code": "HU"},
  {"name": "Iceland", "code": "IS"},
  {"name": "India", "code": "IN"},
  {"name": "Indonesia", "code": "ID"},
  {"name": "Iran (Islamic Republic of)", "code": "IR"},
  {"name": "Iraq", "code": "IQ"},
  {"name": "Ireland", "code": "IE"},
  {"name": "Isle of Man", "code": "IM"},
  {"name": "Israel", "code": "IL"},
  {"name": "Italy", "code": "IT"},
  {"name": "Jamaica", "code": "JM"},
  {"name": "Japan", "code": "JP"},
  {"name": "Jersey", "code": "JE"},
  {"name": "Jordan", "code": "JO"},
  {"name": "Kazakhstan", "code": "KZ"},
  {"name": "Kenya", "code": "KE"},
  {"name": "Kiribati", "code": "KI"},
  {"name": "Korea (the Democratic People's Republic of)", "code": "KP"},
  {"name": "Korea (the Republic of)", "code": "KR"},
  {"name": "Kuwait", "code": "KW"},
  {"name": "Kyrgyzstan", "code": "KG"},
  {"name": "Lao People's Democratic Republic (the)", "code": "LA"},
  {"name": "Latvia", "code": "LV"},
  {"name": "Lebanon", "code": "LB"},
  {"name": "Lesotho", "code": "LS"},
  {"name": "Liberia", "code": "LR"},
  {"name": "Libya", "code": "LY"},
  {"name": "Liechtenstein", "code": "LI"},
  {"name": "Lithuania", "code": "LT"},
  {"name": "Luxembourg", "code": "LU"},
  {"name": "Macao", "code": "MO"},
  {"name": "Madagascar", "code": "MG"},
  {"name": "Malawi", "code": "MW"},
  {"name": "Malaysia", "code": "MY"},
  {"name": "Maldives", "code": "MV"},
  {"name": "Mali", "code": "ML"},
  {"name": "Malta", "code": "MT"},
  {"name": "Marshall Islands (the)", "code": "MH"},
  {"name": "Martinique", "code": "MQ"},
  {"name": "Mauritania", "code": "MR"},
  {"name": "Mauritius", "code": "MU"},
  {"name": "Mayotte", "code": "YT"},
  {"name": "Mexico", "code": "MX"},
  {"name": "Micronesia (Federated States of)", "code": "FM"},
  {"name": "Moldova (the Republic of)", "code": "MD"},
  {"name": "Monaco", "code": "MC"},
  {"name": "Mongolia", "code": "MN"},
  {"name": "Montenegro", "code": "ME"},
  {"name": "Montserrat", "code": "MS"},
  {"name": "Morocco", "code": "MA"},
  {"name": "Mozambique", "code": "MZ"},
  {"name": "Myanmar", "code": "MM"},
  {"name": "Namibia", "code": "NA"},
  {"name": "Nauru", "code": "NR"},
  {"name": "Nepal", "code": "NP"},
  {"name": "Netherlands (the)", "code": "NL"},
  {"name": "New Caledonia", "code": "NC"},
  {"name": "New Zealand", "code": "NZ"},
  {"name": "Nicaragua", "code": "NI"},
  {"name": "Niger (the)", "code": "NE"},
  {"name": "Nigeria", "code": "NG"},
  {"name": "Niue", "code": "NU"},
  {"name": "Norfolk Island", "code": "NF"},
  {"name": "Northern Mariana Islands (the)", "code": "MP"},
  {"name": "Norway", "code": "NO"},
  {"name": "Oman", "code": "OM"},
  {"name": "Pakistan", "code": "PK"},
  {"name": "Palau", "code": "PW"},
  {"name": "Palestine, State of", "code": "PS"},
  {"name": "Panama", "code": "PA"},
  {"name": "Papua New Guinea", "code": "PG"},
  {"name": "Paraguay", "code": "PY"},
  {"name": "Peru", "code": "PE"},
  {"name": "Philippines (the)", "code": "PH"},
  {"name": "Pitcairn", "code": "PN"},
  {"name": "Poland", "code": "PL"},
  {"name": "Portugal", "code": "PT"},
  {"name": "Puerto Rico", "code": "PR"},
  {"name": "Qatar", "code": "QA"},
  {"name": "Republic of North Macedonia", "code": "MK"},
  {"name": "Romania", "code": "RO"},
  {"name": "Russian Federation (the)", "code": "RU"},
  {"name": "Rwanda", "code": "RW"},
  {"name": "Réunion", "code": "RE"},
  {"name": "Saint Barthélemy", "code": "BL"},
  {"name": "Saint Helena, Ascension and Tristan da Cunha", "code": "SH"},
  {"name": "Saint Kitts and Nevis", "code": "KN"},
  {"name": "Saint Lucia", "code": "LC"},
  {"name": "Saint Martin (French part)", "code": "MF"},
  {"name": "Saint Pierre and Miquelon", "code": "PM"},
  {"name": "Saint Vincent and the Grenadines", "code": "VC"},
  {"name": "Samoa", "code": "WS"},
  {"name": "San Marino", "code": "SM"},
  {"name": "Sao Tome and Principe", "code": "ST"},
  {"name": "Saudi Arabia", "code": "SA"},
  {"name": "Senegal", "code": "SN"},
  {"name": "Serbia", "code": "RS"},
  {"name": "Seychelles", "code": "SC"},
  {"name": "Sierra Leone", "code": "SL"},
  {"name": "Singapore", "code": "SG"},
  {"name": "Sint Maarten (Dutch part)", "code": "SX"},
  {"name": "Slovakia", "code": "SK"},
  {"name": "Slovenia", "code": "SI"},
  {"name": "Solomon Islands", "code": "SB"},
  {"name": "Somalia", "code": "SO"},
  {"name": "South Africa", "code": "ZA"},
  {"name": "South Georgia and the South Sandwich Islands", "code": "GS"},
  {"name": "South Sudan", "code": "SS"},
  {"name": "Spain", "code": "ES"},
  {"name": "Sri Lanka", "code": "LK"},
  {"name": "Sudan (the)", "code": "SD"},
  {"name": "Suriname", "code": "SR"},
  {"name": "Svalbard and Jan Mayen", "code": "SJ"},
  {"name": "Sweden", "code": "SE"},
  {"name": "Switzerland", "code": "CH"},
  {"name": "Syrian Arab Republic", "code": "SY"},
  {"name": "Taiwan (Province of China)", "code": "TW"},
  {"name": "Tajikistan", "code": "TJ"},
  {"name": "Tanzania, United Republic of", "code": "TZ"},
  {"name": "Thailand", "code": "TH"},
  {"name": "Timor-Leste", "code": "TL"},
  {"name": "Togo", "code": "TG"},
  {"name": "Tokelau", "code": "TK"},
  {"name": "Tonga", "code": "TO"},
  {"name": "Trinidad and Tobago", "code": "TT"},
  {"name": "Tunisia", "code": "TN"},
  {"name": "Turkey", "code": "TR"},
  {"name": "Turkmenistan", "code": "TM"},
  {"name": "Turks and Caicos Islands (the)", "code": "TC"},
  {"name": "Tuvalu", "code": "TV"},
  {"name": "Uganda", "code": "UG"},
  {"name": "Ukraine", "code": "UA"},
  {"name": "United Arab Emirates (the)", "code": "AE"},
  {"name": "United Kingdom of Great Britain and Northern Ireland (the)", "code": "GB"},
  {"name": "United States Minor Outlying Islands (the)", "code": "UM"},
  {"name": "Uruguay", "code": "UY"},
  {"name": "Uzbekistan", "code": "UZ"},
  {"name": "Vanuatu", "code": "VU"},
  {"name": "Venezuela (Bolivarian Republic of)", "code": "VE"},
  {"name": "Viet Nam", "code": "VN"},
  {"name": "Virgin Islands (British)", "code": "VG"},
  {"name": "Virgin Islands (U.S.)", "code": "VI"},
  {"name": "Wallis and Futuna", "code": "WF"},
  {"name": "Western Sahara", "code": "EH"},
  {"name": "Yemen", "code": "YE"},
  {"name": "Zambia", "code": "ZM"},
  {"name": "Zimbabwe", "code": "ZW"}
];

const selectCountry = document.getElementById('country_list');

if (selectCountry) {
  for (let i = 0; i < countries.length; i++) {
    let opt = document.createElement('option');
    opt.value = countries[i].code;
    opt.innerHTML = countries[i].name;
    selectCountry.appendChild(opt);
  }
}

// Function to handle the click event when URL contains '#tryon'
function handleTryOnTrigger() {
  const tryOnButton = document.querySelector('.virtooal-tryon-btn-product-page');
  if (tryOnButton && tryOnButton.style.display !== 'none') {
    tryOnButton.click();
  }
}

// Function to observe the DOM for the target element's appearance
function observeForTargetElement() {
  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList' || mutation.type === 'subtree') {
        const tryOnButton = document.querySelector('.virtooal-tryon-btn-product-page');
        if (tryOnButton) {
          // Observe changes to the target element's attributes (e.g., style)
          const styleObserver = new MutationObserver(() => {
            if (tryOnButton.style.display !== 'none') {
              styleObserver.disconnect();
              handleTryOnTrigger();
            }
          });
          styleObserver.observe(tryOnButton, { attributes: true, attributeFilter: ['style'] });
        }
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

// Self-instantiating function to check the URL hash and trigger the click event if needed
(function() {
  if (window.location.hash === '#tryon') {
    observeForTargetElement();
  }
})();


// Accessibility fixes
(function () {
  let isProcessing = false;

  function processAccessibeWidgets() {
    document.querySelectorAll('access-widget-ui').forEach(widget => {
      if (!widget.shadowRoot) return;

      try {
        widget.shadowRoot.querySelectorAll('[data-acsb="skipLinks"]')
          .forEach(el => el.remove());

        const trigger = widget.shadowRoot.querySelector('.acsb-trigger.acsb-widget[role="button"]');
        if (trigger) trigger.removeAttribute('role');
      } catch (error) {
        console.warn('Shadow DOM access failed:', error);
      }
    });
  }

  function processLightDomTrigger() {
    const trigger = document.querySelector('.acsb-trigger.acsb-widget[role="button"]');
    if (trigger) trigger.removeAttribute('role');
  }

  function processDownShift() {
    const downShiftDiv = document.querySelector('#downshift-0-menu');
    if (downShiftDiv) {
      downShiftDiv.removeAttribute('role');
    }
  }

  function fixAccessibilityIssues() {
    if (isProcessing) return;
    isProcessing = true;

    processAccessibeWidgets();
    processLightDomTrigger();
    processDownShift();
    isProcessing = false;
  }

  document.addEventListener('DOMContentLoaded', fixAccessibilityIssues);
  window.addEventListener('load', () => setTimeout(fixAccessibilityIssues, 500));

  [500, 1000, 2000, 3000].forEach(delay =>
    setTimeout(fixAccessibilityIssues, delay)
  );

  new MutationObserver(mutations => {
    if (mutations.some(m => m.addedNodes.length > 0)) {
      setTimeout(fixAccessibilityIssues, 100);
    }
  }).observe(document.body, { childList: true, subtree: true });
})();